import React, { useState } from "react";
import PropTypes from "prop-types";
import { SkedIcon } from "ui";

const HashtagListWrapper = ({ children, defaultIsOpen, title, count }) => {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);
  const icon = isOpen ? "icon-down-close" : "icon-left-close";

  return (
    <div>
      <button
        type="button"
        className="flex items-center gap-2 px-3 py-1.5 w-full text-left font-semibold text-sm text-neutral-700 hover:bg-neutral-50 rounded-md transition-colors"
        onClick={() => setIsOpen(!isOpen)}
      >
        <SkedIcon icon={icon} size="12" />
        <span>{title}</span>
        {count !== undefined && count > 0 && (
          <span className="text-xs font-normal text-neutral-500">
            ({count})
          </span>
        )}
      </button>
      {isOpen && <div className="mt-1 mb-2">{children}</div>}
    </div>
  );
};

HashtagListWrapper.propTypes = {
  children: PropTypes.node,
  defaultIsOpen: PropTypes.bool,
  title: PropTypes.string,
  count: PropTypes.number,
};

export default HashtagListWrapper;
